// extracted by mini-css-extract-plugin
export default {"how":"Guidelines_how__cBpe0","banner":"Guidelines_banner__RCXSZ"};